import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { List } from 'immutable';
import { Link } from 'react-router-dom';

import { MOBILE_BREAKPOINT, PRODUCTS, PRODUCT_ROUTES } from '../../../constants';

import NavMain from '../NavMain';

import IconMBLogo from '../../../../images/mb-branding.svg';

import styles from './Navigation.module.scss';

const Navigation = ({
  tags,
  topFive,
  history,
  loading,
  requestNavigation,
  uiVersion,
  product,
  widthSize,
  casinoLobbies,
  liveCasinoLobbies,
  virtualLobbies,
  cinemaMode,
  casinoVisibilityRestricted,
  virtualsAllowed,
  pendingUIUpdate,
  inPlayTags,
}) => {
  const azSports = tags.filter((tag) => (
    tag.type === 'SPORT' || tag.urlName === 'live-betting'
  ));

  const productName = product.replace('-', ' ');

  const productHomeUrl = PRODUCT_ROUTES[product];

  useEffect(() => {
    if ([PRODUCTS.mbzero, PRODUCTS.exchange].includes(product)) {
      requestNavigation();
    }
  }, [product]);

  if (widthSize <= MOBILE_BREAKPOINT) {
    return null;
  }

  return (
    <div className={styles.navigation}>
      {!cinemaMode && (
        <Link
          to={productHomeUrl}
          className={styles.logoContainer}
          data-hook="mb-home-logo"
        >
          <span className={styles.logo}>
            <IconMBLogo />
          </span>
          <div className={styles.productName}>
            <span>{productName}</span>
          </div>
        </Link>
      )}
      <NavMain
        topFive={topFive}
        loading={loading}
        history={history}
        tags={tags}
        azSports={azSports}
        virtualsAllowed={virtualsAllowed}
        uiVersion={uiVersion}
        product={product}
        casinoLobbies={casinoLobbies}
        liveCasinoLobbies={liveCasinoLobbies}
        virtualLobbies={virtualLobbies}
        cinemaMode={cinemaMode}
        pendingUIUpdate={pendingUIUpdate}
        casinoVisibilityRestricted={casinoVisibilityRestricted}
        inPlayTags={inPlayTags}
      />
    </div>
  );
};

Navigation.propTypes = {
  tags: PropTypes.instanceOf(List),
  topFive: PropTypes.instanceOf(List),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }),
  widthSize: PropTypes.number.isRequired,
  requestNavigation: PropTypes.func.isRequired,
  virtualsAllowed: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  cinemaMode: PropTypes.bool.isRequired,
  uiVersion: PropTypes.string.isRequired,
  pendingUIUpdate: PropTypes.bool.isRequired,
  product: PropTypes.string.isRequired,
  casinoLobbies: PropTypes.instanceOf(Object).isRequired,
  liveCasinoLobbies: PropTypes.instanceOf(Object).isRequired,
  virtualLobbies: PropTypes.instanceOf(Object),
  casinoVisibilityRestricted: PropTypes.bool.isRequired,
  inPlayTags: PropTypes.instanceOf(List).isRequired,
};

export default Navigation;
